import { Prisma } from "@prisma/client";

export const exhibitorInspectorValues =
  Prisma.validator<Prisma.ExhibitorInspectorDefaultArgs>()({
    select: {
      id: true,
      userId: true,
      clearPassword: true,
      user: {
        select: {
          id: true,
          email: true,
          firstName: true,
          lastName: true,
          connectId: true,
        },
      },
    },
  });

export type ExhibitorInspector = Prisma.ExhibitorInspectorGetPayload<
  typeof exhibitorInspectorValues
>;
